var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook2024(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2803 22.383H6.63313C4.87391 22.383 3.18683 21.6958 1.94287 20.4725C0.698911 19.2492 0 17.5903 0 15.8603V6.52296C0 4.79298 0.698911 3.13385 1.94287 1.91057C3.18683 0.687291 4.87391 0 6.63313 0H16.2803C17.1514 0 18.0139 0.168711 18.8187 0.496516C19.6235 0.824322 20.3547 1.30486 20.9706 1.91057C21.5866 2.51627 22.0752 3.23525 22.4085 4.02665C22.7418 4.81804 22.9134 5.66636 22.9134 6.52296V15.8611C22.9132 17.5909 22.2143 19.2498 20.9703 20.4729C19.7264 21.696 18.0394 22.383 16.2803 22.383ZM14.4515 22.383V12.873H17.7186L18.2087 9.16536H14.4507V6.79926C14.4507 5.72697 14.7554 4.99517 16.3293 4.99517H18.3386V1.68035C17.3662 1.57956 16.389 1.53066 15.4112 1.53406C12.5141 1.53406 10.5309 3.26185 10.5309 6.43373V9.16457H7.2547V12.8722H10.5309V22.3823L14.4515 22.383Z",
    fill: "#004B81"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook2024);
export default __webpack_public_path__ + "static/media/facebook 2024.52abc5d1.svg";
export { ForwardRef as ReactComponent };